<template>
  <div :class="customClass">
    <div v-if="radioSlides.length > 0" class="atom-radio-open">
      <div v-if="!disableRadio" class="atom-radio-open__radio">
        <img
          :class="{ hidden: !show ? false : true }"
          src="@/assets/icons/radio/img-pan-radio-ruka.png"
        />
      </div>
      <div class="atom-radio-open__question pointer" @click="toggleShowHelp">
        <img src="@/assets/icons/question/ico-ico-vykricnik.svg" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["radioSlides", "show", "customClass", "disableRadio"],
  mounted() {
    //this.toggleShowHelp();
  },
  methods: {
    toggleShowHelp() {
      this.$emit("updateShowRadioHelp", this.show ? false : true);
    }
  }
};
</script>

<style lang="scss" scoped></style>
